define.alias("shared/components/shared/post-tagging/select/tag-select-item", "calendar/components/shared/post-tagging/select/tag-select-item");